import * as cookieutils from "./cookieutils";
import { v4 as uuidv4 } from 'uuid';

let thirdparty = false;

export function thirdPartyPresent(third: boolean) {
    thirdparty = third;
}

export function loadInternalCookies(common: boolean) {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (common || thirdparty) {
        var utms = urlParams.get("utm_source");
        var utmc = urlParams.get("utm_campaign");
        var utmm = urlParams.get("utm_medium");
        var as1 = urlParams.get("as1");
        var as2 = urlParams.get("as2");
        var assite = urlParams.get("assite");
        var da1 = urlParams.get("da1");
        var da2 = urlParams.get("da2");
        var dasite = urlParams.get("dasite");
        if (utms != null) cookieutils.setCookie("utms", utms);
        if (utmc != null) cookieutils.setCookie("utmc", utmc);
        if (utmm != null) cookieutils.setCookie("utmm", utmm);
        if (as1 != null) cookieutils.setCookie("as1", as1);
        if (as2 != null) cookieutils.setCookie("as2", as2);
        if (assite != null) cookieutils.setCookie("assite", assite);
        if (da1 != null) cookieutils.setCookie("da1", da1);
        if (da2 != null) cookieutils.setCookie("da2", da2);
        if (dasite != null) cookieutils.setCookie("dasite", dasite);

        if (common) {
            var tldCatId = urlParams.get("categoryid");
            var emailtrackingid = urlParams.get("emailtrackingid");

            if (tldCatId != null) cookieutils.setCookie("tldCatId", tldCatId);
            if (emailtrackingid != null) cookieutils.setCookie("emailtrackingid", emailtrackingid);

            if (utms == "bilhandel") {
                cookieutils.setCookie("bilhandel", "bilhandel");
            }

            if (cookieutils.getCookie("userid") == null) {
                let uuid = uuidv4();
                cookieutils.setCookieWithDate("userid", uuid, 7);
            }

            var referrer = document.referrer;
            if (referrer?.length > 0) {
                var parsed = parseURL(referrer)
                var local = location.hostname;
                if (parsed !== local) {
                    cookieutils.setCookie("referrer", referrer);
                }
            }
        }
    }
    else {
        cookieutils.deleteCookie("utms");
        cookieutils.deleteCookie("utmc",);
        cookieutils.deleteCookie("utmm");
        cookieutils.deleteCookie("as1");
        cookieutils.deleteCookie("as2");
        cookieutils.deleteCookie("assite");
        cookieutils.deleteCookie("da1");
        cookieutils.deleteCookie("da2");
        cookieutils.deleteCookie("dasite");
    }
}

export function loadGoogle() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    var gclid = urlParams.get("gclid");
    if (gclid != null) cookieutils.setCookie("gclid", gclid);
    var tldgclid = urlParams.get("tldgclid");
    if (tldgclid != null) cookieutils.setCookie("tldgclid", tldgclid);
}

export function loadFacebook() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    var fbclid = urlParams.get("fbclid");
    if (fbclid != null) cookieutils.setCookie("fbclid", fbclid);
}

function parseURL(url) {
    var a = document.createElement('a');
    a.href = url;
    return a.hostname;
}